import { WaveBlockKind } from "@vida/wave-core";

export const WAVE_FEED_MAX_WIDTH = 1280;
export const WAVE_FEED_GUTTER_WIDTH = 140;
export const WAVE_FEED_RAIL_WIDTH = 36;
export const WAVE_FEED_ROW_SPACING = 12;
export const WAVE_FEED_NODE_SIZE = 28;
export const WAVE_FEED_AVATAR_SIZE = 32;
export const WAVE_EDITOR_CONTENT_PADDING = 20;

export type WaveFeedDensity = "comfortable" | "compact";

export function waveFeedRowSpacing(density: WaveFeedDensity): number {
  return density === "compact" ? 8 : 12;
}

export function blockKindColor(kind: WaveBlockKind): string {
  switch (kind) {
    case WaveBlockKind.Text:
    case WaveBlockKind.Heading:
      return "#3b82f6";
    case WaveBlockKind.Poll:
    case WaveBlockKind.Decision:
      return "#8b5cf6";
    case WaveBlockKind.Task:
    case WaveBlockKind.TodoList:
    case WaveBlockKind.Signoff:
      return "#10b981";
    case WaveBlockKind.Gallery:
      return "#ec4899";
    case WaveBlockKind.File:
      return "#0891b2";
    default:
      return "#ea580c";
  }
}

export function blockKindGlyph(kind: WaveBlockKind): string {
  switch (kind) {
    case WaveBlockKind.Text:
      return "T";
    case WaveBlockKind.Heading:
      return "H";
    case WaveBlockKind.Decision:
      return "↳";
    case WaveBlockKind.Signoff:
      return "✍";
    case WaveBlockKind.Poll:
      return "◫";
    case WaveBlockKind.Task:
      return "☑";
    case WaveBlockKind.TodoList:
      return "☰";
    case WaveBlockKind.Gallery:
      return "▦";
    case WaveBlockKind.File:
      return "📎";
    case WaveBlockKind.TidePageRef:
      return "Pg";
    case WaveBlockKind.DriftTodoRef:
      return "✓";
    case WaveBlockKind.ReefArticleRef:
      return "N";
    case WaveBlockKind.PulseDocRef:
      return "▶";
    default:
      return "•";
  }
}

export function formatTimelineGutterTime(iso: string | undefined): string {
  if (!iso) return "—";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });
}

export function relationGlyph(relation: string | undefined): string {
  switch (relation) {
    case "summary":
      return "↳";
    case "analysis":
      return "🔍";
    case "note":
      return "📝";
    case "derived":
      return "⎘";
    case "agent_task":
      return "🐋";
    case "agent_response":
      return "🤖";
    default:
      return "↳";
  }
}

export function relationLabel(relation: string | undefined): string {
  switch (relation) {
    case "summary":
      return "Riassunto";
    case "analysis":
      return "Analisi @analista";
    case "note":
      return "Nota";
    case "derived":
      return "Derivato";
    case "agent_task":
      return "Task agente";
    case "agent_response":
      return "Risposta agente";
    default:
      return "Collegato";
  }
}

export function formatBlockMetadataLabel(
  createdAt?: string,
  updatedAt?: string,
): string | null {
  if (!createdAt) return null;
  const created = new Date(createdAt);
  if (Number.isNaN(created.getTime())) return null;
  const createdLabel = created.toLocaleString("it-IT", {
    dateStyle: "medium",
    timeStyle: "short",
  });
  if (!updatedAt) return `Creato ${createdLabel}`;
  const updated = new Date(updatedAt);
  if (Number.isNaN(updated.getTime()) || updated.getTime() - created.getTime() <= 1000) {
    return `Creato ${createdLabel}`;
  }
  const updatedLabel = updated.toLocaleString("it-IT", {
    dateStyle: "medium",
    timeStyle: "short",
  });
  return `Creato ${createdLabel} · Modificato ${updatedLabel}`;
}
